import { EMAIL_ITEM_ID_KEY } from '../Email.constants'

export const QA_NAME_EMAIL_ATTACHED_THREADS_MODAL = 'EmailThreadsAttachModal'

export const EMAIL_ATTACHED_THREADS_MODAL_TABLE_CELL_NAME = {
  date: 'date',
  message: 'message',
  participants: 'participants',
}

export const EMAIL_ATTACHED_THREADS_MODAL_TABLE_ROW_ACTIONS_CONFIG = {
  itemIdKey: EMAIL_ITEM_ID_KEY,
}
